produtos.component('produtos.conteudos.moduloModalComponent', {
    templateUrl: 'produtos/produtoDetalhes/conteudos/moduloModal/moduloModal.html',
    controller: 'produtos.moduloModalController',
    controllerAs: '$modal',
    bindings: { config: '=' }
});

produtos.controller('produtos.moduloModalController', [ '$scope', 'coreLanguage', 'coreFb', function($scope, $text, $fb){
    const $ctrl = this;
    $scope.$text = $text;

    const formErrorsDefault = {
        nome:{},
        ordem:{},
        idSessao:{}
    };

    $ctrl.onBlur = (field) => {
        if(!$ctrl.formErrors){ $ctrl.formErrors = angular.copy(formErrorsDefault); }

        $ctrl.formErrors[field] = {
            field: !$scope.formModulo[field].$valid,
            hint: !$scope.formModulo[field].$valid
        };
    };

    $ctrl.close=()=>{
        $ctrl.config.dados = {};
        $ctrl.config.show = false;
        $ctrl.formErrors = angular.copy(formErrorsDefault);
    };

    $ctrl.validateForm=()=>{
        if($scope.formModulo.$valid){
            $ctrl.config.confirm($ctrl.config.dados);
        }else{
            Object.keys(formErrorsDefault).forEach(key=>{ $ctrl.onBlur(key); });
        }
    };

    $ctrl.uploadCapa=(event)=>{
        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingFile=true;

        $fb.storage.upload(`/capa_modulos`, event.target.files[0]).then(url => {
            $ctrl.config.dados.capaUrl = url
            $ctrl.loadingFile=false;
        })
    };

}]);